<!-- Application Shell -->
<div class="app-shell" [class.app-shell--embed]="hideAppChrome()">
  @if (!hideAppChrome()) {
    <header class="app-header">
      <div class="app-header__left">
        <a class="app-header__brand" routerLink="/" title="Back to Dashboard">
          <img
            class="app-header__logo"
            src="/RFILogo3.png"
            alt="retailfixit"
          />
        </a>
        <!-- "V1 Main Job Page" lives in each job page's tab bar (app-v1-job-page-link); Admin Portal V1,
             Settings and Setup, Customer Profile and Accounting live on the V2 dashboard (Home) tiles. -->
      </div>
      <nav class="app-header__nav">
        <button type="button" class="nav-link" (click)="openAddJob()">
          Add Job
        </button>
        <span class="app-header__version">v2.0.0.2</span>
      </nav>
    </header>
  }
  <main class="app-main" [class.app-main--embed]="hideAppChrome()">
    <router-outlet />
  </main>
  <!-- Global job chat (v1 UI parity); shown on every route including embed — except the public
       forgot-password page, where there is no signed-in staff member to chat as. -->
  @if (!isPublicPage()) {
    <app-live-chat-widget />
    <!-- One session-expired alert for the whole tab (VE-SIGNALR): shown when the live connection's token expires
         or the hub answers 401. -->
    <app-session-expired-banner />
  }

  @defer (when addJobDeferred()) {
    <app-add-job #addJobRef />
  }
</div>
